<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-content-jump">
        <div class="footer-content-about">
          <p class="jump-title">关于我们</p>
          <a :href="`${urlOrigin}/#/ett/about?id=introduce`" target="_blank">企业简介</a>
          <a :href="`${urlOrigin}/#/ett/about?id=connect`" target="_blank">联系我们</a>
        </div>
      </div>
      <div class="footer-info">
        <div class="footer-tel">
          <img style="margin-right: 24px;" class="footer-qrcode" src="../assets/images/ax.png" alt="">
          <p class="app-name">爱学</p>
          <div>郑重承诺：<br/>
            爱学App不向学前儿童、中小学生提供校外学科类培训服务<br/>
            爱学App不能用于违规学科培训<br/>
            爱学App仅面向学校或者教育行政部门提供服务，<br/>
            不对社会机构和个人提供服务
          </div>
        </div>
        <div class="footer-wechat" style="margin-left:58px">
          <img style="padding: 4px;" class="footer-qrcode" src="../assets/images/axp.png" alt="">
          <p class="app-name">爱学派</p>
          <div>郑重承诺：<br/>
            爱学派App不向学前儿童、中小学生提供校外学科类培训服务<br/>
            爱学派App不能用于违规学科培训<br/>
            爱学派App仅面向学校或者教育行政部门提供服务，<br/>
            不对社会机构和个人提供服务
          </div>
        </div>
      </div>
    </div>
    <div class="footer-record-num">
      <p>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202007369" target="_blank">京公网备案 11010202007369</a>
        <a href="http://beian.miit.gov.cn/" target="_blank">&nbsp;&nbsp;京ICP备10032123号</a>
        <a :href="`${urlOrigin}/#/icp`" target="_blank">&nbsp;&nbsp;京ICP证061033号</a>
        <span>&nbsp;&nbsp;Copyright ©{{curYear}} 北京四中龙门网络教育技术有限公司</span>
      </p>
      <p>投诉电话 010-82082260&nbsp;&nbsp;投诉邮箱 tousu@etiantian.com</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "PageFooter",
  data() {
    return {
      curYear: new Date().getFullYear(),
      urlOrigin: window.location.origin
    }
  },
};
</script>
<style scoped lang="scss">
.footer {
  height: 380px;
  background: linear-gradient(135deg, #1647BD, #246BCB, #30AAF8);
  padding-top: 40px;
  .footer-content {
    width: 1066px;
    max-width: 100%;
    border-bottom: 1px solid #CDD3ED;
    margin: 0 auto;
    padding: 0 100px 19px 92px;
    display: flex;
    // align-items: flex-end;
    justify-content: space-between;
    .footer-content-jump {
      display: flex;
      align-items: flex-start;
      font-size: 20px;
      flex-shrink: 0;
      padding-top: 42px;
      .footer-content-about {
        margin-right: 48px;
      }
      .jump-title {
        font-weight: 500;
        color: #CDD3ED;
        line-height: 20px;
      }
      a {
        font-size: 16px;
        display: block;
        font-weight: 500;
        color: #7391D7;
        margin-top: 24px;
        line-height: 16px;
      }
    }
    .footer-info {
      display: flex;
      flex-wrap: nowrap;
      font-size: 10px;
      font-weight: 400;
      color: #CDD3ED;
      line-height: 14px;
      .footer-qrcode {
        display: block;
        width: 98px;
        height: 98px;
        border-radius: 4px;
        margin-bottom: 10px;
        background: #fff;
        // position: absolute;
        // top: -118px;
        // left: 50%;
        // transform: translateX(-50%);
        // display: none;
      }
      .app-name {
        width: 98px;
        text-align: center;
        margin-bottom: 20px;
      }
      .tips {
        font-size: 12px;
        font-weight: 500;
        color: #CDD3ED;
        line-height: 20px;
      }
    }
  }
  .footer-record-num {
    text-align: center;
    padding-top: 20px;
    font-size: 12px;
    font-weight: 500;
    color: #CDD3ED;
    line-height: 28px;
  }
}
</style>
